import { Dispatch, SetStateAction } from 'react'
import { useSearchParams } from 'react-router-dom'
import { PER_PAGE } from '@const/pagination'
import { SortStates } from '@templates/ListPageLayout/Filters/Sorter'
import { useGetInstructionsQuery } from '@services/instructions'
import useItemsFilters, { FilterState } from './useItemsFilters'

type Params = {
  initFilters?: FilterState
  pagination?: boolean
  limit?: number
  skip?: boolean
  initOrder?: { order: Record<string, SortStates> }
}

const useInstructions = (params?: Params) => {
  const {
    initFilters = {},
    pagination = true,
    limit = PER_PAGE,
    skip,
    initOrder,
  } = params || {}

  const [searchParams, setSearchParams] = useSearchParams()
  const initPage = Number.parseInt(searchParams.get('page') || '1', 10)

  const { filters, setFilters, setPage, setOrder, page } = useItemsFilters(
    initFilters,
    pagination,
    limit,
    initOrder,
    initPage
  )

  const handleSetPage: Dispatch<SetStateAction<number>> = (value) => {
    const newPage = value instanceof Function ? value(page) : value

    setPage(newPage)
    setSearchParams(
      (prev) => {
        if (newPage === 1) {
          prev.delete('page')
        } else {
          prev.set('page', String(newPage))
        }
        return prev
      },
      { replace: true }
    )
  }

  const state = useGetInstructionsQuery(filters, { skip })

  return {
    ...state,
    setPage: handleSetPage,
    setFilters,
    setOrder,
    page,
  }
}

export default useInstructions
